<template>
    <!-- 查询输入框开始 -->
    <a-form
        ref="formRef"
        name="advanced_search"
        class="ant-advanced-search-form mySerachForm"
        :model="formState"
        @finish="onFinish"
      >
        <a-row :gutter="24">
        
          <a-col  :span="8">
              <a-form-item  name="name" label="姓名" >
                <a-input class="input" v-model:value="formState.name" placeholder="请输入用户姓名"></a-input>
              </a-form-item>
            </a-col>
            <a-col  :span="8"><a-form-item name="good_at"  label="授课内容" >
                <a-input  class="input"  v-model:value="formState.good_at" placeholder="请输入角色名称"></a-input>
              </a-form-item>
            </a-col>
            <a-col  :span="8"><a-form-item name="grade"  label="指导员等级" >
                <a-input  class="input"  v-model:value="formState.grade" placeholder="请输入角色名称"></a-input>
              </a-form-item>
            </a-col>
         
        </a-row>
        <a-row>
          <a-col :span="24" style="text-align: right">
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button style="margin: 0 8px" @click="() => formRef.resetFields()">重置</a-button>
            <a-button type="primary" @click="showModel">新增</a-button>
          </a-col>
        </a-row>
      </a-form>
  
    <!-- 查询输入框结束 -->
  
    <a-table :columns="columns" :data-source="data" size="small" :pagination="false"  bordered>
      <template #bodyCell="{ column, text, record }">
        <template v-if="['name', 'age'].includes(column.dataIndex)">
          <div>
            <a-input
              v-if="editableData[record.id]"
              v-model:value="editableData[record.id][column.dataIndex]"
              style="margin: -5px 0"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'operation'">
          <div class="editable-row-operations">
            <span v-if="editableData[record.id]">
              <a-typography-link @click="save(record.id)">提交</a-typography-link>
              <a-popconfirm title="确定取消吗?" @confirm="cancel(record.id)">
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <!-- <a @click="edit(record.id)">更新</a> -->
              <a-popconfirm class="onDelete" title="确定删除吗?" @confirm="onDelete(record.id)"> <a>删除</a> </a-popconfirm>  
               <a  @click="onEdit(record.id)">编辑</a>
            </span>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination class="pagination" v-model:current="current" v-model:total="total"  v-model:pageSize="pageSize" :hideOnSinglePage="true" @change="onChange" @showSizeChange="showSizeChange" />
    
    <!-- 可编辑表格结束 -->
  
  
    <!-- 新增页面开始 -->
    <a-modal
        v-model:visible="visible"
        :title="saveFormState.id ?'编辑老师':'新增老师'"
        ok-text="提交"
        cancel-text="取消"
        @ok="submitTeacher"
        @cancel="afterClose"
      >
        <a-form ref="saveFormRef" :model="saveFormState" layout="vertical" name="user_form_in_modal">
        
      
          <a-form-item label="机构名称" v-if="isShowAddModel" name="team_id" :rules="[{ required:false, message: '请输入机构' }]">
          <a-select v-model:value="saveFormState.team_id" @change="handleChangeTeam">
            <a-select-option value="">请选择</a-select-option>
		        <a-select-option v-for="item in teamNameList" :value="item.team_id" :key="item.team_id" :label="item.team_name">
			        {{ item.team_name }}
		        </a-select-option>
	        </a-select>
        </a-form-item>



          <a-form-item  label="姓名" name="name"  :rules="[{ required: true, message: '请输入用户姓名' }]">
            <a-input v-model:value="saveFormState.name" />
          </a-form-item>
  
          <a-form-item label="手机号" name="mobile" :rules="[{ required: true, message: '请输入手机号' }]">
            <a-input v-model:value="saveFormState.mobile" />
          </a-form-item>
          <a-form-item label="密码" name="passwd" :rules="[{ required: false, message: '请输入密码' }]">
            <a-input v-model:value="saveFormState.passwd" />
          </a-form-item>
          <a-form-item label="介绍" name="desc" :rules="[{ required: true, message: '请输入介绍' }]">
            <a-input v-model:value="saveFormState.desc" />
          </a-form-item>
          <a-form-item label="擅长课程" name="good_at" :rules="[{ required:true, message: '请输入擅长课程' }]">
            <a-checkbox-group v-model:value="saveFormState.good_at">
              <a-checkbox v-for="item in formData.goodAtList"  :key="item.dict_key" :value="item.dict_key"  :name="item.dict_value">{{item.dict_value}}</a-checkbox>
               </a-checkbox-group>
          </a-form-item>
          <a-form-item label="服务区域" name="area" :rules="[{ required:true, message: '请输入服务区域' }]">
            <a-checkbox-group v-model:value="saveFormState.area">
              <a-checkbox v-for="item in formData.areaList"  :key="item.dict_key" :value="item.dict_key"  :name="item.dict_value">{{item.dict_value}}</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
          <a-form-item label="等级" name="grade" :rules="[{ required:true, message: '请输入等级' }]">
            <a-input v-model:value="saveFormState.grade" />
          </a-form-item>
          <a-form-item label="证书编号" name="certno" :rules="[{ required:false, message: '请输入证书编号' }]">
            <a-input v-model:value="saveFormState.certno" />
          </a-form-item>
          <a-form-item label="身份证号码" name="idcard" :rules="[{ required:false, message: '请输入身份证号码' }]">
            <a-input v-model:value="saveFormState.idcard" />
          </a-form-item>
          <a-form-item name="certfile" label="证书" extra="请上传有效证书，不要太大，照片清晰">
              <a-upload
                v-model:fileList="saveFormState.upload"
                :custom-request="customUploadRequest"
                
                list-type="picture"
              >
                <a-button>
                  <template #icon><UploadOutlined /></template>
                  上传文件
                </a-button>
              </a-upload>
            </a-form-item>
        </a-form>
      </a-modal>
  
       
 
  
    <!-- 新增页面结束 -->
  </template>
  <script setup>
  import { cloneDeep } from 'lodash-es';
  import axios from  'axios'
  import {message} from 'ant-design-vue'
  import {reactive, ref,onMounted,toRefs} from 'vue'
  import { $teacherList,$deleteTeacher,$uploadCert,$submitTeacher,$getTeacher } from '../api/systemTeacher.js';
  import { $fetchTeamOptions} from '../api/course.js';
  //清空表单时可以用的上，其他的没什么用
  const good_at_list=JSON.parse(localStorage.getItem("good_at_list"));
  const area_list=JSON.parse(localStorage.getItem("area_list"));
  const saveFormState=reactive({
    id:'',
    name: '',
    mobile:'',
    team_name:'',
    team_id:'',
    idcard:'',
    certno:'',
    passwd: '',
    desc:'',
    good_at:"",
    area:"",
    grade:"",
    certfile:"",
    upload:[]
  })
  console.log(good_at_list)

  const formData = reactive({
    goodAtList:good_at_list,
    areaList:area_list
})
  const formRef = ref();
  const saveFormRef = ref();
  const visible = ref(false);
  const showModel = () => {
    saveFormState.id=""
    reset();
    saveFormState.upload=[]
    visible.value = true;
    
  }
  
const reset=()=>{
  saveFormState.id="";
  
  saveFormState.id="";
  saveFormState.id="";//.id;
      saveFormState.name="";//.name;
      saveFormState.mobile="";//.mobile;
      saveFormState.passwd="";
      saveFormState.desc="";//.desc;
      saveFormState.good_at="";
      saveFormState.area="";
      saveFormState.grade="";//.grade;
      saveFormState.upload="";
      saveFormState.team_id="";//.team_id;
      saveFormState.team_name="";//.team_name;

      saveFormState.certno="";//.certno;
      saveFormState.idcard="";//.idcard;
      visible.value = true;
}
  
//编辑按钮。根据id查询信息
const onEdit=async (id)=>{
  let res=await $getTeacher({id})
  // console.log(res)
  if(res.code==="success"){
      //赋值，并显示
      saveFormState.id=res.data.id;
      saveFormState.name=res.data.name;
      saveFormState.mobile=res.data.mobile;
      saveFormState.passwd="";
      saveFormState.desc=res.data.desc;
      saveFormState.good_at=JSON.parse(res.data.good_at);
      saveFormState.area=JSON.parse(res.data.area);
      saveFormState.grade=res.data.grade;
      saveFormState.upload=JSON.parse(res.data.upload);
      saveFormState.team_id=res.data.team_id;
      saveFormState.team_name=res.data.team_name;

      saveFormState.certno=res.data.certno;
      saveFormState.idcard=res.data.idcard;
      visible.value = true;
  }else{
    message.error(res.msg)
  }
}

const teamNameList = ref([]);
const isShowAddModel=ref(false)
onMounted(() => {
 let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  if(userInfo.team_id == 'admin'){
    isShowAddModel.value=true;
  }
 fetchTeamOptions();
});
const fetchTeamOptions = async () => {
  let res=await $fetchTeamOptions();
  console.log(res)
  if(res.code=='success'){
   const data =res.data;
   teamNameList.value=res.data;
   saveFormState.team_id=data[0].team_id
   saveFormState.team_name=data[0].team_name
    console.log(saveFormState.team_id)

  }
};

const handleChangeTeam = async (value,option) =>{
  const selectedKey = option.key; // 或者使用 option.value 获取 key
  const selectedText = option.label; // 获取文本
  console.log("selectedKey="+selectedKey)
  console.log("selectedText="+selectedText)
  saveFormState.team_id=selectedKey
  saveFormState.team_name=selectedText;


}
  //删除
  let onDelete=async (id)=>{
    let userInfo=JSON.parse(localStorage.getItem("userInfo"));
  if(userInfo.team_id == 'admin' || userInfo.name=='admin' ){
    message.error("系统管理员账号不能删除"); return false;
  }
    let res=await $deleteTeacher({id})
    // console.log(res)
    if(res.code=='success'){
        message.success(res.msg)
        //再次查询
        loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
    }else{
      message.error(res.msg);
    }
  }
  
  
  const afterClose=()=>{
    saveFormRef.value.resetFields();
  }
  const submitTeacher =async () => {
    console.log(saveFormState);
    if (!saveFormRef.value) return;
    try{


    
    saveFormRef.value.validateFields(['mobile', 'name','desc','good_at','area','grade']).then( async () => {

      if(saveFormState.mobile==null || saveFormState.mobile==''){
      message.error("手机号不能为空");return false;
    }
    if(saveFormState.name==null || saveFormState.name==''){
      message.error("姓名不能为空");return false;
    }
    //点击提交
    let userInfo=JSON.parse(localStorage.getItem("userInfo"));
    if(userInfo.team_id == 'admin'){
      if(saveFormState.team_id==null || saveFormState.team_id==''){
        message.error("请选择机构");return false;
      }
    }else{
      saveFormState.team_id=userInfo.team_id;
      saveFormState.team_name=userInfo.team_name;
    }
    let res=await $submitTeacher(saveFormState);
    if(res.code=='success'){
      visible.value = false;
      message.success(res.msg)
      
      saveFormRef.value.resetFields();
  
      //在调用一次列表查询的方法
      loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
    }else{
      message.error(res.msg)
    }
    })
  } catch (errorInfo) {
    console.error('验证失败:', errorInfo);
  }
  }

  /**
   * 上传图片方法2：将图片转成base64的方式，当做成一个普通的字符串进行提交，使用统一封装的axios工具类request.js
   * @param param0 
   */
   const customUploadRequest =async ({ file, onSuccess, onError, onProgress }) => {
    console.log("自定义上传图片开始");
    const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload =async () => {
        const base64String = reader.result;
          const param={
            "imgBase64Data":base64String,
            "fileName":file.name,
          }
        let res=await $uploadCert(param);
        if(res.code=='success'){
          onSuccess(res);  // 上传成功回调
         
        }else{
          onError(res.msg);  // 上传失败回调
        }
      };

      reader.onerror = (error) => {
        onError(error);
      };
      
  }
  

  /**
   * 上传图片方法1：直接用multipart/form-data的方式进行上传文件,该方法直接使用了axios工具进行发送请求，未用到我们统一封装的axios工具类
   * @param param0 
   */
  const customUploadRequest1 =async ({ file, onSuccess, onError, onProgress }) => {
    console.log("自定义上传图片开始");
    const formData = new FormData();
      formData.append('file', file);
      formData.append('userId', 123);  // 附加参数
      axios.post('/api/ajaxUpload.do', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: progressEvent => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress({ percent });  // 更新进度条
        },
      })
      .then(response => {
        onSuccess(response.data);  // 上传成功回调
      
      })
      .catch(error => {
        onError(error);  // 上传失败回调
      });
  }
  
  
  // 提交查询按钮
  const onFinish = values => {
   loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
  };
  
  
  
  //查询搜索框的数据绑定
  const formState = reactive({
    name: '',
    good_at: '',
    grade:""
  });
 
  const columns = [
  {
      title: 'ID',
      dataIndex: 'id',
      width: '10%',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      width: '10%',
    },
    {
      title: '手机号码',
      dataIndex: 'mobile',
      width: '10%',
    },
    {
      title: '身份证号码',
      dataIndex: 'idcard',
      width: '10%',
    },
    {
      title: '证书编号',
      dataIndex: 'certno',
      width: '10%',
    },
    {
      title: '所属机构',
      dataIndex: 'team_name',
      width: '10%',
    },
    {
      title: '授课内容',
      dataIndex: 'good_at',
      width: '20%',
    },
    {
      title: '指导员等级',
      dataIndex: 'grade',
      width: '10%',
    },
    {
      title: '操作',
      dataIndex: 'operation',
    },
  ];
  let tableData =reactive({
          data:[],
          current:ref(1),
          total:ref(1),
          pageSize:10
  });
  //查询数据库
  let loadData=async (params)=>{
    params.name=formState.name;
    params.good_at=formState.good_at;
    params.grade=formState.grade;
    let res=await $teacherList(params);
    if(res.code=='success'){
        //取出数据data和总页数，分页使用
        console.log(res)
        let {total,pageSize,pageNo,list}=res.data
        tableData.data=list
        tableData.current=ref(pageNo)
        tableData.total=ref(total)
        tableData.pageSize=ref(pageSize)
    }
  }
  loadData({pageNo:1,pageSize:10}); 
  let {data,current,total,pageSize} =toRefs(tableData)
  
  const dataSource = ref(data);
  const editableData = reactive({});
  const edit = key => {
    console.log('key:'+(key-1))
    editableData[key] = cloneDeep(dataSource.value.filter(item => key === item.id)[0]);
  };
  const save =async (key) => {
    Object.assign(dataSource.value.filter(item => key === item.id)[0], editableData[key]);
    let res=await $submitTeacher(editableData[key]);
    delete editableData[key];
    if(res.code=='success'){
      message.success('保存成功')
      loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
    }else{
      message.error('保存失败')
    }
  };
  const cancel = key => {
    delete editableData[key];
  };
  
  
  function onChange(page, pageSize) {
    let params= {pageNo:page,pageSize:pageSize}
    loadData(params);
  }
  function showSizeChange(current, size){
    let params= {pageNo:current,pageSize:size}
    loadData(params);
  }
  </script>
  <style scoped>
  .editable-row-operations a {
    margin-right: 8px;
  }
  .pagination{
    margin-top: 40px;
    float: right;
  }
  
  .mySerachForm{
    margin-bottom: 20px;
    
    
  }
  .input{
      border-radius: 2px;
    }
    .onEdit{
      margin-left: 10px;
    }
  </style>